/**
 * Валидация полей на фронте.
 */

const EMAIL_MAX_LENGTH = 128;
/** Упрощённый формат email: local@domain.tld, без пробелов, домен с точкой и зоной не короче 2 символов */
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Номера СНГ и международный формат: 10–15 цифр (РФ, Беларусь, Казахстан, Украина, Узбекистан и др.) */
const PHONE_MIN_DIGITS = 10;
const PHONE_MAX_DIGITS = 15;

/**
 * Валидация email.
 * @param {string} value
 * @returns {{ valid: boolean, message?: string }}
 */
export function validateEmail(value) {
  const s = value == null || typeof value !== "string" ? "" : value.trim();
  if (s === "") return { valid: true };
  if (s.length > EMAIL_MAX_LENGTH) {
    return { valid: false, message: `Не длиннее ${EMAIL_MAX_LENGTH} символов` };
  }
  if (!EMAIL_REGEX.test(s)) {
    return { valid: false, message: "Некорректный email (например, name@example.com)" };
  }
  return { valid: true };
}

/**
 * Валидация телефона: только цифры (пробелы, скобки, дефисы, + игнорируются).
 * Принимаются номера СНГ и международный формат: 10–15 цифр (РФ, РБ, КЗ, УК, УЗ и др.).
 * @param {string} value
 * @returns {{ valid: boolean, message?: string }}
 */
export function validatePhone(value) {
  const s = value == null || typeof value !== "string" ? "" : value.trim();
  if (s === "") return { valid: true };
  const digits = s.replace(/\D/g, "");
  if (digits.length === 0) {
    return { valid: false, message: "Введите цифры номера" };
  }
  if (digits.length < PHONE_MIN_DIGITS || digits.length > PHONE_MAX_DIGITS) {
    return {
      valid: false,
      message: `В номере должно быть от ${PHONE_MIN_DIGITS} до ${PHONE_MAX_DIGITS} цифр (например, 9123456789, +375 29 123-45-67, +7 701 123-45-67)`,
    };
  }
  return { valid: true };
}
